import * as React from 'react';
import { cn } from '@/utils/utils';
import { FOCUS } from '@/components/ui/recipes';

interface DragHandleProps extends React.HTMLAttributes<HTMLDivElement> {
  /** What dragging it does, as its accessible name (Reorder story). */
  label: string;
  /** vertical: a tall grip beside a card; horizontal: a short one on a row. */
  orientation?: 'vertical' | 'horizontal';
}

/** The grip that drags a card or row to reorder it: six dots in the strong ink on the page's tone, brand ink on hover. Spread the drag library's attributes and listeners onto it. */
export const DragHandle = React.forwardRef<HTMLDivElement, DragHandleProps>(({ label, orientation = 'vertical', className, ...props }, ref) => (
  <div
    ref={ref}
    role="button"
    tabIndex={0}
    aria-label={label}
    className={cn(
      'flex cursor-grab touch-none items-center justify-center rounded-lureo-radius-lg border-lureo-border-width border-lureo-line/50 bg-lureo-page text-lureo-ink-strong shadow-lureo-shadow-control transition-colors hover:border-lureo-brand-ink hover:text-lureo-brand-ink active:cursor-grabbing',
      orientation === 'vertical' ? 'h-16 w-5' : 'h-5 w-8',
      FOCUS,
      className,
    )}
    {...props}
  >
    <span aria-hidden className={cn('grid gap-0.5', orientation === 'vertical' ? 'grid-cols-2' : 'grid-cols-3')}>
      {Array.from({ length: 6 }, (_, i) => (
        <span key={i} className="h-1 w-1 rounded-full bg-current opacity-60" />
      ))}
    </span>
  </div>
));
DragHandle.displayName = 'DragHandle';
